import { useEffect, useState } from 'react';
import { ServiceProviderUnitModel } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

const spReceiveCitizenClient = moduleClientFactory.createCitizenServiceProviderReceiveCitizenClient(true);

export function useServiceProviderUnit(serviceProviderUnitId: string | undefined) {
  const [serviceProviderUnit, setServiceProviderUnit] = useState<ServiceProviderUnitModel | undefined>();

  useEffect(() => {
    async function loadServiceProviderUnit() {
      if (!serviceProviderUnitId) {
        setServiceProviderUnit(undefined);
        return;
      }
      const response = await spReceiveCitizenClient.getServiceProviderUnit({
        serviceProviderUnitId: { value: serviceProviderUnitId },
      });
      setServiceProviderUnit(response.serviceProviderUnit);
    }
    loadServiceProviderUnit();
  }, [serviceProviderUnitId]);

  return serviceProviderUnit;
}
